import { LogDownloadReq, UpdatedAtTz } from "../type/log";

const pad = (n: number) => String(n).padStart(2, "0");

/** Date を YYYY-MM-DD（ローカル日付）にする。toISOString は UTC へずれるため使わない */
const toDateString = (d: Date) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export class LogAdapter {
  /**
   * 指定した日が属する月の 1日〜末日 を集計期間にする。
   * `new Date(y, m + 1, 0)` は翌月0日＝当月末日。
   */
  static toInputDTO(
    base: Date = new Date(),
    updatedAtTz: UpdatedAtTz = "utc"
  ): LogDownloadReq {
    const start = new Date(base.getFullYear(), base.getMonth(), 1);
    const end = new Date(base.getFullYear(), base.getMonth() + 1, 0);
    return {
      start_date_utc: toDateString(start),
      end_date_utc: toDateString(end),
      updated_at_tz: updatedAtTz,
    };
  }

  /** 保存ファイル名。例: xcausal-log_2026-09.csv */
  static toFileName(req: LogDownloadReq): string {
    return `xcausal-log_${req.start_date_utc.slice(0, 7)}.csv`;
  }
}
